import Transcription from './Transcription';

export default Transcription;
